import { DatabaseRecordType } from "../enums";
var LockedRecord = /** @class */ (function () {
    function LockedRecord(obj) {
        this.companyId = obj && obj.companyId || "";
        this.id = obj && obj.id || "";
        this.userCode = obj && obj.userCode || "";
        this.recordType = obj && obj.recordType || DatabaseRecordType.Message;
    }
    LockedRecord.isLockedToUser = function (lockedUser, userCode) {
        return (lockedUser === null || lockedUser === void 0 ? void 0 : lockedUser.code) && userCode.equalIgnoreCase(lockedUser.code);
    };
    LockedRecord.createLockedRecord = function (companyId, id, userCode, recordType) {
        var result = new LockedRecord();
        result.companyId = companyId;
        result.id = id;
        result.userCode = userCode;
        result.recordType = recordType;
        return result;
    };
    return LockedRecord;
}());
export { LockedRecord };
